module.exports = __webpack_public_path__ + "img/e880c7f6e6cbc49c1b3d61b4601bfd92.4fc79d9f.jpg";